// assets/dm-cart.js – hält Hauptposition und Extras zusammen (≤ 1 KB). Im Layout mit defer laden.
// Regel: Wird eine Position mit _dm_key entfernt oder auf 0 gesetzt, werden alle Positionen mit passendem _dm_parent ebenfalls entfernt.
// Ändert der Kunde die Menge der Hauptposition, werden Extras proportional angepasst.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  async function sync() {
    if (busy) return; busy = true;
    try {
      const cart = await (await fetch(root + 'cart.js')).json();
      const parents = Object.fromEntries(cart.items.filter((i) => i.properties?._dm_key).map((i) => [i.properties._dm_key, i.quantity]));
      const updates = {};
      // Alu-Platte statt Folie (28.10.2026): Menge folgt immer der Hauptposition, damit Warenkorb-Zeile und Aufpreis zusammenpassen
      cart.items.forEach((i) => { const p = i.properties?._dm_parent; if (!p) return; if (!(p in parents)) updates[i.key] = 0; else if (i.handle === 'aufpreis-alu-platte' && i.quantity !== parents[p]) updates[i.key] = parents[p]; });
      if (Object.keys(updates).length) { await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) }); location.pathname.startsWith(root + 'cart') ? location.reload() : document.dispatchEvent(new CustomEvent('dm:cart-synced')); }
    } finally { busy = false; }
  }
  // Dawn feuert nach jeder Mengenänderung „cart-update“ über PubSub; zusätzlich Fallback auf fetch-Hook
  document.addEventListener('dm:added', sync);
  // /cart ändert Mengen über Links (Seitenwechsel) – darum auch beim Laden abgleichen
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  const f = window.fetch; window.fetch = async (...a) => { const r = await f(...a); const u = String(a[0]?.url || a[0]); if (/\/cart\/(change|update)/.test(u)) setTimeout(sync, 50); return r; };
})();
